import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Wrestling", to: "/wrestling" },
  { label: "Comedy", to: "/comedy" },
  { label: "About", to: "/about" },
  { label: "Gallery", to: "/gallery" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        background: scrolled ? "rgba(0,0,0,0.92)" : "rgba(0,0,0,0.55)",
        backdropFilter: "blur(8px)",
        borderBottom: scrolled ? "1px solid var(--hairline-dark)" : "1px solid transparent",
        transition: "background-color 0.4s ease, border-color 0.4s ease",
      }}
    >
      <div className="container-editorial">
        <div className="flex items-center justify-between" style={{ height: "clamp(80px, 11vh, 112px)" }}>
          <Link to="/" data-testid="header-logo-link" className="flex items-center" aria-label="Hustle Promotions home">
            <img
              src="/assets/logo-white.png"
              alt="Hustle Promotions"
              style={{ height: "clamp(56px, 8vw, 90px)", width: "auto", display: "block" }}
            />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center" style={{ gap: "clamp(1.5rem, 2.6vw, 2.75rem)" }} data-testid="desktop-nav">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                {item.label}
              </NavLink>
            ))}
            <Link to="/book" className="btn btn-solid" data-testid="nav-book-cta">
              Book A Show
            </Link>
          </nav>

          {/* Mobile toggle */}
          <button
            type="button"
            className="lg:hidden inline-flex items-center justify-center"
            style={{ width: 44, height: 44, color: "var(--white)" }}
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={26} strokeWidth={1.5} /> : <Menu size={26} strokeWidth={1.5} />}
          </button>
        </div>
      </div>
      </header>

      {/* Mobile overlay */}
      {open && (
        <div
          data-testid="mobile-nav-overlay"
          className="lg:hidden fixed inset-0"
          style={{ background: "#000", zIndex: 60, display: "flex", flexDirection: "column", overflowY: "auto" }}
        >
          <div
            className="container-editorial"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              height: "clamp(80px, 11vh, 112px)",
              flexShrink: 0,
            }}
          >
            <img
              src="/assets/logo-white.png"
              alt="Hustle Promotions"
              style={{ height: "clamp(56px, 8vw, 90px)", width: "auto", display: "block" }}
            />
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Close menu"
              data-testid="mobile-menu-close"
              style={{ width: 44, height: 44, color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
            >
              <X size={28} strokeWidth={1.5} />
            </button>
          </div>
          <nav
            className="container-editorial"
            style={{ display: "flex", flexDirection: "column", gap: "0.25rem", marginTop: "clamp(1rem, 4vh, 2.5rem)", paddingBottom: "2.5rem" }}
          >
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className="font-cond"
                style={{
                  fontSize: "clamp(1.5rem, 7vw, 2.1rem)",
                  fontWeight: 500,
                  textTransform: "uppercase",
                  letterSpacing: "0.14em",
                  color: "#fff",
                  textDecoration: "none",
                  padding: "0.7rem 0",
                  borderBottom: "1px solid var(--hairline-dark)",
                }}
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/book"
              onClick={() => setOpen(false)}
              className="btn btn-solid"
              data-testid="mobile-nav-book-cta"
              style={{ marginTop: "2rem", width: "100%" }}
            >
              Book A Show
            </Link>
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;
